<template>
  <div class="box">

    <!-- 地图容器 -->
    <div id="container"></div>



    <!-- 多选框 -->
    <el-checkbox-group v-model="checkList" class="checkboxGroup">


      <!-- 全城市管理需要显示 -->
      <el-select v-model="city_list_name" placeholder="请选择城市" style="width: 150px;" @change="cityChange" clearable
        @clear="cityClear" v-show="showList">
        <el-option v-for="item in city_list" :key="item.city.city_code" :label="item.city.name" :value="item">
        </el-option>
      </el-select>



      <div class="div-color" style="font-size: 14px;cursor: pointer;font-weight:800;margin: 0 0 0 20px;"
        v-for="(item, index) in priceListAll" :key="index">

        {{item.alias}} -
        {{item.num}}

      </div>

      <!-- <el-checkbox v-for="(item, index) in checbBoxText" :label="item.status" checked
        @change="checkboxChenge($event,item.status) ">
        <div style="padding-left: 10px;">
          {{item.alias}} -
          {{priceList[item.status]}}
        </div>

      </el-checkbox> -->
      <div style="font-size: 14px;cursor: pointer;font-weight:600;margin: 0 0 10px 20px;">
        当前在线<span style="margin: 0 5px;color: red;">{{all}}</span>人
      </div>

      <i class='el-icon-refresh' style="font-size: 20px;cursor: pointer;font-weight: 800;margin-left: 20px;"
        @click="searchPeople"></i>
      <el-button style="padding: 4px 8px;margin-left: 20px" @click="put = !put"
                 :class="{'el-icon-d-arrow-right':!put,'el-icon-d-arrow-left':put}">
        {{put?'隐藏':'展开'}}
      </el-button>
    </el-checkbox-group>



    <!-- 推荐服务人员 -->
    <div class="main-right" v-if="put">

      <!-- 位置信息 -->
      <div class="top">

        <el-row>
          <el-col :span="24">
            <div class="left-top-col" style="position: relative;">
              <span style="color:rgb(68, 141, 201) ;font-size: 20px" class="iconfont icon-zuobiaofill"></span>
              <el-input v-model="start_name" clearable
                        class="input-place" @input="onInput(start_name)">
              </el-input>
              <ul id="start-panel" v-if="start_panel_show">
                <li class="list" v-for="(item, index) in start_panel_innerHtml" :key="index"
                    @click="listClick(item.location.lng,item.location.lat,item.name)">

                  <div style="padding-left: 20px;">
                    <p class='list-name'>
                      <img :src="require(`@/assets/markPoint${index+1}.png`)" alt=""
                           style="width: 20px;height: 20px;display: inline-block;">
                      <!--                                            {{Number(index)+1}}-->
                      <span style="display: inline-block;">{{ item.title }}</span>
                    </p>
                    <p class='list-address'>{{ item.address }}</p>
                  </div>

                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>


      <div class="bottom">





        <i class='el-icon-refresh' style="font-size: 20px;cursor: pointer;float: right;font-weight: 800;"
           @click="searchDriver(search_driver_data.lng,search_driver_data.lat,slider_km)"></i>

        <div class="block">
          <span class="demonstration fs14-w500">搜索半径({{slider_km}}公里)</span>
          <el-slider v-model="slider" :step="5" :min="5" show-stops @change="sliderChange"
                     :show-tooltip="false">
          </el-slider>
        </div>


        <el-table :data="rightToptableData" ref="multipleTable" max-height="200">



          <el-table-column prop="real_name" label="姓名" min-width="120" fixed align="center">


            <template slot-scope="scope">

              <div style="display: flex">

                <!--司机段位图片-->
                <img
                        style="width: 30px;height: 30px;margin-right: 5px;display: inline-block;"
                        :src="scope.row.dan == 0 ? require('@/assets/11.png'):(scope.row.dan == 1 ? require('@/assets/22.png'):(scope.row.dan == 2 ? require('@/assets/33.png'):require('@/assets/44.png')))"
                >


                <!--司机姓名-->
                <p style="display: block">
                  {{ scope.row.name }}
                </p>


              </div>

            </template>


          </el-table-column>

          <el-table-column prop="linear_distance" label="直线" min-width="120" align="center">
            <template slot-scope="scope">
              {{ Math.floor(scope.row.distance/10)/100 }}km
            </template>
          </el-table-column>


          <el-table-column prop="status" label="状态" min-width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.status=='0'?'未听单':'听单中' }}
            </template>
          </el-table-column>



          <el-table-column prop="phone" label="电话" min-width="100" align="center">
          </el-table-column>





        </el-table>

      </div>



    </div>




  </div>
</template>

<script>
  var trafficLayer;
  var ruler1;
  var infoWindow;
  var markers = [];
  var _this, text, circle, marker, polyline1, polyline2, polyline3,circle,placeSearch,
    leagueMarker,map,startMarker;



  import axios from 'axios'; // AJAX封装类
  import {
    config
  } from '../../../utils/config'; //配置
  import bus from '../../common/bus';
  import tipModel from './tips.vue';
  export default {
    components: {
      tipModel
    },

    created() {

      _this = this;

      bus.$on('firstlog', msg => {

        _this.firstlog = msg

      });


      _this.$nextTick(function () {

        _this.onSocket();

      })








      // 获取司机状态
      _this.$post(
        "/driver/statusConf"
      ).then(res => {

        _this.checbBoxText = res.data;
        console.log(_this.checbBoxText)

      }).catch((err) => {

      })




      setTimeout(() => {


        // 地图初始化
        map = new TMap.Map('container', {
            zoom: 11,
            viewMode: '2D'
        });

        var limit_num = 10;
        if(localStorage.getItem('city_tag')=='KUNMING'){
          limit_num = 500
        }

        // 联盟商家坐标
        _this.$post(
          "/admin.php/Business/ipcShoppingLists", {
            page: 1,
            limit: limit_num,
            shop_name: '',
            city_code: ''
          }).then(res => {

          if (res.data.length > 0) {

            for (let i = 0; i < res.data.length; i++) {

              leagueMarker = new TMap.MultiMarker({
                  map: map,  //指定地图容器
                  //样式定义
                  styles: {
                      //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                      "myStyle": new TMap.MarkerStyle({
                          "width": 25,  // 点标记样式宽度（像素）
                          "height": 34, // 点标记样式高度（像素）
                          "src": require('@/assets/League.png'),  //图片路径
                          "offset": { x: -13, y: -30 }
                      })
                  },
                  //点标记数据数组
                  geometries: [{
                      "id": res.data[i].id,   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                      "styleId": 'myStyle',  //指定样式id
                      "position": new TMap.LatLng(res.data[i].lat, res.data[i].lng),  //点标记坐标位置
                      "properties": {//自定义属性
                          "title": "marker1"
                      }
                  }
                  ]

              });

            }

          }

        }).catch((err) => {

        })


        // 使用地图工具(平移工具，测距工具)
        // AMap.plugin(['AMap.RangingTool', 'AMap.CitySearch', 'AMap.Geocoder', 'AMap.Driving'], function () {

        //   // map.addControl(new AMap.CitySearch())

        // })
        // 将地图绑定点击事件   点击关闭信息窗口
        map.on('click', this.closePop);



        // 路况图层
        // trafficLayer = new AMap.TileLayer.Traffic({
        //   zIndex: 10
        // });
        // 测距功能
        // ruler1 = new AMap.RangingTool(map);
        // 将路况图层加入到地图
        // trafficLayer.setMap(map);
        // map.add(trafficLayer);
        // 隐藏路况图层
        // trafficLayer.hide();
        // 弹出提示
        map.on("complete", function () {

          log.success("地图加载完成！");

        });




      }, 1);



    },

    beforeUpdate() {

      // _this.onSocket();

    },


    mounted() {


      this.city_code = '';

      this.searchPeople();




        // 司机假数据
        _this.$post(
                "/zheng/drivers",
        ).then(res => {

          for (let i =0;i<res.data.length;i++){

            console.log(res.data[i]);
            // // 添加司机标签
            _this.addDriver(res.data[i].driver_code, res.data[i].real_name,res.data[i].lng,res.data[i].lat,
                    res.data[i].status, res.data[i].server_status,res.data[i].dan);
          }


        })

        // 请求城市列表接口   获取围栏信息
        _this.$post(
            "/admin.php/city/getCityDetails",
          )
          .then(res => {

            if (res.data.free_area_coordinate_array != null && res.data.free_area_coordinate_array != '[]' && res.data.free_area_coordinate_array != '') {

              var path1 = JSON.parse(res.data.free_area_coordinate_array);

              path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);
              var polygonPath = path1.map(coord => new TMap.LatLng(coord[1], coord[0]));
            }





            if (res.data.far_area_coordinate_array != null && res.data.far_area_coordinate_array != '[]' && res.data.far_area_coordinate_array != '') {

              var path2 = JSON.parse(res.data.far_area_coordinate_array);

              path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);
              var polygonPath2 = path2.map(coord => new TMap.LatLng(coord[1], coord[0]));

            }




            if (res.data.effective_area_coordinate_array != null && res.data.effective_area_coordinate_array != '[]' && res.data.effective_area_coordinate_array != '') {

              var path3 = JSON.parse(res.data.effective_area_coordinate_array);

              path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);
              var polygonPath3 = path3.map(coord => new TMap.LatLng(coord[1], coord[0]));

            }


            // 创建小围栏(绿色)
            polyline1 = new TMap.MultiPolyline({
                map: map,
                //折线样式定义
                styles: {
                    'style_green': new TMap.PolylineStyle({
                        'color': '#008000', //线填充色
                        'width': 6, //折线宽度
                        'lineCap': 'butt' //线端头方式
                    }),
                },
                //折线数据定义
                geometries: [
                    {//第1条线
                        'id': 'pl_1',//折线唯一标识，删除时使用
                        'styleId': 'style_green',//绑定样式名
                        'paths': polygonPath
                    }
                ],
            });
            if (path2) {

              // 创建大围栏(粉色)
              polyline2 = new TMap.MultiPolyline({
                  map: map,
                  //折线样式定义
                  styles: {
                      'style_pink': new TMap.PolylineStyle({
                          'color': '#FF69B4', //线填充色
                          'width': 6, //折线宽度
                          'lineCap': 'butt' //线端头方式
                      }),
                  },
                  //折线数据定义
                  geometries: [
                      {//第1条线
                          'id': 'pl_2',//折线唯一标识，删除时使用
                          'styleId': 'style_pink',//绑定样式名
                          'paths': polygonPath2
                      }
                  ],
              });

            }



            if (path3) {
              // 创建大围栏(黑色)
              polyline3 = new TMap.MultiPolyline({
                  map: map,
                  //折线样式定义
                  styles: {
                      'style_black': new TMap.PolylineStyle({
                          'color': '#000000', //线填充色
                          'width': 6, //折线宽度
                          'lineCap': 'butt' //线端头方式
                      })
                  },
                  //折线数据定义
                  geometries: [
                      {//第1条线
                          'id': 'pl_3',//折线唯一标识，删除时使用
                          'styleId': 'style_black',//绑定样式名
                          'paths': polygonPath3
                      }
                  ],
              });
            }


            var x = res.data.name.indexOf('/');

            for (var i = 0; i < 1; i++) {
              x = res.data.name.indexOf('/', x + 1);
            }

            // console.log(x);

            // 如果为市级
            if (x < 0) {

              // 截取城市名称 如:XXXX / 截取字段
              var city_name = res.data.name.slice(res.data.name.indexOf('/') + 2)



            } else {

              // 截取城市名称 如:XXXX / 截取字段 / XXXX
              var city_name = res.data.name.slice(x + 2)

            }

            let areaCode;


            if(res.data.area_code.length== 4){
              areaCode = String(res.data.area_code)+'00'
            }else{
              areaCode = String(res.data.area_code)
            }


            _this.area_code = areaCode;

            // 将城市赋值
            _this.currentCity = city_name;

            console.log(res.data.name);
            console.log(city_name);

            //地图显示当前城市
            // if (polygonPath.length > 0) {
            //     map.setCenter(new TMap.LatLng(polygonPath[0].lat, polygonPath[0].lng));
            //     _this.center = new TMap.LatLng(polygonPath[0].lat, polygonPath[0].lng)
            // } else {
            //     var center = res.data.center;
            //     const [lng, lat] = center.split(',').map(Number);
            //     console.log(center);
            //     _this.center = new TMap.LatLng(lat, lng)
            //     map.setCenter(new TMap.LatLng(lat, lng));
            // }
            var center = res.data.center;
            const [lng, lat] = center.split(',').map(Number);
            console.log(center);
            _this.center = new TMap.LatLng(lat, lng)
            map.setCenter(new TMap.LatLng(lat, lng));



          }).catch((err) => {

          })



    },
    data() {
      return {

        firstlog: true,


        start_name:'',


        put:false,


        start_panel_show:'',


        start_panel_innerHtml:[],


        search_driver_data: {
          lng: '',
          lat: ''
        },


        // 滑块
        slider: 15,
        slider_km: 3,

        socket_relink_num: 0,

        sendData: {
          ws_mode: '',
          port: 'admin',
          platform: 'pc',
          token: '',
          hash_key: '',
          // city_tag: 'CHANGCHUN'
        },

        driver: [],

        driverMarks_status: [],

        //全城市管理员可以选择城市
        city_list: [],
        city_list_name: '',
        city_code: '',
        showList: false,
        all: '',

        // 行政编码
        area_code: '',

        checkList: [],
        checbBoxText: [],

        markPoint: [],


        // 当前城市
        currentCity: '',

        // 城市列表拉出开关
        city_group_show: false,

        // 城市名称
        city_name_group: [],

        // city_code_group:[],

        // 右上表格数据
        rightToptableData: [],
        priceList: [],
        priceListAll: [],

        // 表单数据
        submit_data: {
          driver_code: '',
          order_mode_code: '',
          start_name: '',
          start_coordinate: '',
          end_name: '',
          end_coordinate: '',
          consumer_name: '',
          consumer_phone: '',
          order_time: '',
          driver_number: '',
          remarks: ''
        },



        // 司机头像路径
        url: '',


        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          name: '',
          company_code: '',
          phone: '',
          telephone: '',
          boss: ''
        },
        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
        circle: null,
        is_window_show: false,
      }
    },
    watch: {
      firstlog() {
        if (_this.firstlog) {

          _this.onSocket();


        } else {

          // 关闭socket
          if (_this.global.ws) {
            _this.global.ws.close();
          }

        }
      }
    },
    methods: {
      startMark(lng, lat){
        if (startMarker) {
          startMarker.setGeometries([]);
        }


        _this.search_driver_data.lng = lng;
        _this.search_driver_data.lat = lat;

        // 添加起点标记
        // 创建一个 Icon
        startMarker = new TMap.MultiMarker({
            map: map,
            styles: {
                "startStyle": new TMap.MarkerStyle({
                    "width": 25,
                    "height": 34,
                    "src": '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
                    "offset": { x: -13, y: -30 }
                })
            },
            geometries: [{
                "id": "start_marker",
                "styleId": "startStyle",
                "position": new TMap.LatLng(lat, lng),
                "draggable": true,
                "properties": {
                    "title": "起点"
                }
            }]
        });

      },
      listClick(lng, lat, text){
        // 如果地图存在标记点则清除
        if (_this.markPoint.length > 0) {

          for (let j = 0; j < _this.markPoint.length; j++) {

             _this.markPoint[j].setGeometries([])


          }

        }

        // 清除所有点标记
        this.markPoint.map((item) => {
            item.setGeometries([])
        })
        this.markPoint = []

        _this.start_name = text;

        if (startMarker) {

          startMarker.setGeometries([]);

        }

        _this.startMark(lng, lat);


        // 如果目的地为空则地图自适应中心点
        if (_this.submit_data.end_name == '' || _this.submit_data.end_name == null) {

          var startPosition = startMarker.getGeometries()[0].position;
          startPosition = new TMap.LatLng(startPosition.lat, startPosition.lng);
          map.setCenter(startPosition);

        }

        _this.start_panel_show = false;
        _this.circleInit();

        // 搜索司机
        _this.searchDriver(lng, lat, _this.slider_km);

      },

      onInput(val){

        if (val != '' && val != null){
          _this.start_panel_show = true;

          var keywords = _this.start_name;

          // 腾讯地图地点搜索
          var options = {
              keyword: keywords,
              location: _this.center
          };

          var search = new TMap.service.Suggestion();

          search.getSuggestions(options).then(function(result) {

              console.log(result);

              _this.start_panel_innerHtml = [];


              if (result) {
                console.log(_this.markPoint);

                // console.log(result);
                // 如果地图存在标记点则清除
                if (_this.markPoint.length > 0) {

                  for (let j = 0; j < _this.markPoint.length; j++) {

                     _this.markPoint[j].setGeometries([])


                  }

                }
                for (let i = 0; i < result.data.length; i++) {
                  // console.log(result.poiList.pois[i],'列表数据');

                  // 添加列表内容
                  if (result.data[i]) {


                    _this.start_panel_innerHtml.push(result.data[i]);
                    //  添加地图标记点
                    //  markPoint
                    var markPoint = new TMap.MultiMarker({
                        map: map,
                        styles: {
                            "markStyle" : new TMap.MarkerStyle({
                                "width": 25,
                                "height": 34,
                                "src": require(`@/assets/markPoint${i + 1}.png`),
                                "offset": { x: -13, y: -30 }
                            })
                        },
                        geometries: [{
                            "id": "mark_" + i,
                            "styleId": 'markStyle',
                            "position": new TMap.LatLng(
                                result.data[i].location.lat,
                                result.data[i].location.lng
                            ),
                            "properties": {
                                "title": result.data[i].title
                            }
                        }]
                    });

                    _this.markPoint[i] = markPoint;
                  }

                }

              }


            });

        }else{
          _this.rightToptableData = [];

          _this.search_driver_data={
            lng:'',
            lat:''
          }

          _this.start_panel_innerHtml = [];

          if (circle) {
            circle.remove('circle_1')
          }

          if (_this.markPoint.length > 0) {

            for (let j = 0; j < _this.markPoint.length; j++) {

                 _this.markPoint[j].setGeometries([])

            }

          }

          if (startMarker) {

            startMarker.setGeometries([]);

          }

        }

      },

      searchDriver(lng, lat, radius){
        // 获取司机状态
        _this.$post(
                "/driver/driverNearby",{
                  lng:lng,
                  lat:lat,
                  search_radius:radius
                }
        ).then(res => {

          _this.rightToptableData = res.data;

        }).catch((err) => {

        });
      },

      // 地图圆形初始化
      circleInit() {
        if (circle) {
          circle.remove('circle_1')
        }

        // 腾讯地图：从 MultiMarker 的 geometry 中获取位置
        var startGeometries = startMarker.getGeometries();
        var startPosition = startGeometries[0].position;
        circle = new TMap.MultiCircle({
            map: map,
            styles: { // 设置圆形样式
                'circle': new TMap.CircleStyle({
                'color': 'rgba(41,91,255,0.16)',
                'showBorder': true,
                'borderColor': 'rgba(41,91,255,1)',
                'borderWidth': 2,
                }),
            },
            geometries: [{
                id: 'circle_1',
                styleId: 'circle',
                center: new TMap.LatLng(startPosition.lat, startPosition.lng),
                radius: _this.slider_km * 1000,
            }],
        });
        map.setZoom(16)

      },

      // 滑块数据改变时触发
      sliderChange(val) {

        _this.slider_km = val / 5;

        if (startMarker) {


          _this.circleInit();

          _this.searchDriver(startMarker.getPosition().lng, startMarker.getPosition().lat, _this.slider_km);


        }


      },


      cityChange(e) {

        // console.log(e)
        this.city_list_name = e.city.name

        console.log(this.city_list_name);


        var address = `${e.city.name}市政府`

        var geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
        });

        geocoder.getLocation(address, function (status, result) {


          _this.area_code = result.geocodes[0].adcode;

          // 平移地图
          map.panTo([result.geocodes[0].location.lng, result.geocodes[0].location.lat]);


          // 将城市赋值
          _this.currentCity = result.geocodes[0].addressComponent.city;

          // 设置地图层级
          map.setZoom(11)
        });

        this.city_code = e.city.city_code

        this.searchPeople()

      },


      cityClear() {

        this.city_code = ''

        this.searchPeople()

      },



      // 查询人数
      searchPeople() {

        _this.priceList = []


        _this.$post(
          "/statistics/getDriverStatusSubmit", {
            city_code: _this.city_code
          }
        ).then(res => {

          let obj = res.data;
          console.log(res)

          this.all = res.data.server_status_all
          let arr = Object.values(obj).forEach(element => {
            console.log(element.num)
            _this.priceList.push(element.num)
          });

          _this.priceListAll = res.data;

          console.log(_this.priceListAll);

        }).catch((err) => {

        })
      },

      localSocket() {
        if ("WebSocket" in window) {
          console.log("您的浏览器支持 WebSocket!");

          _this.ws = new WebSocket(_this.$getSocketUrl());

          _this.global.setWs(_this.ws);

          _this.ws.onopen = _this.webSocketOnOpen; // 连接到通信

          _this.ws.onerror = _this.webSocketOnError; // 发生错误时


          _this.ws.onclose = _this.webSocketOnClose; // 通信中断


        } else {
          // 浏览器不支持 WebSocket
          console.log("您的浏览器不支持 WebSocket!");
        }
      },

      // 建立连接成功后的状态
      webSocketOnOpen() {


        // 发送数据
        // _this.global.ws.send(JSON.stringify(_this.sendData));


      },

      // 关闭连接
      webSocketOnClose() {

        console.log('socket已关闭');

        // console.log(_this.firstlog);

        if (_this.firstlog && _this.socket_relink_num < 10) {

          setTimeout(() => {

            _this.socket_relink_num += 1;
            _this.onSocket();

          }, 2000);



        } else if (_this.socket_relink_num >= 10) {

          _this.$notify({

            message: 'WebSocket链接失败,请刷新浏览器重试',
            duration: 0,
            type: 'warning',
            offset: 80

          });

        }


      },

      //连接失败的事件
      webSocketOnError(res) {


      },


      onSocket() {

        // var token = localStorage.getItem(config.localStorage_token_name);

        // // 哈希值
        // var hash_key = this.$hash_key();
        // _this.sendData.ws_mode = 'link';
        // _this.sendData.token = token;
        // _this.sendData.hash_key = hash_key;


        // 建立Socket连接
        _this.localSocket();



        // 长连接接收内容
        _this.global.ws.onmessage = function (res) {


          var resData = JSON.parse(res.data);

          _this.$driverState(resData);

          if (resData.identification == "link" && resData.header == "success") {
            console.log(resData);

            var data = {
              "server_status_0": 1,
              "server_status_1": 1,
              'server_status_2': 1,
              'server_status_3': 1,
              'server_status_4': 1,
              'server_status_5': 1,
              'server_status_6': 1,
              'switch': 1,
              'status': 88 // 1只返回听单中司机，2所有状态司机都返回
            }



            var sendData = {
              "ws_mode": 'driverControl',
              "driver_control_synchronization": JSON.stringify(data)
            }

            _this.global.ws.send(JSON.stringify(sendData));
            _this.$sendPing();
            // console.log(JSON.stringify(sendData));


          } else if (resData.header == "error") {
            // 接收到弹窗信息

            _this.$message.error(resData.msg)



          } else if (resData.identification == "driver_control" && resData.header == "success") {
            // 如果接收到司机数据

            // 添加司机标签
            _this.addDriver(resData.data.driver_code, resData.data.real_name, resData.data.lng, resData.data.lat,
              resData.data.status, resData.data.server_status, resData.data.dan);


          } else if (resData.identification == "driver_offline" && resData.header == "success") {
            // 如果接收到司机下线数据

            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {


              // 清除对应的司机标签
              // _this.driver[resData.data.driver_code].setMap(null);
              _this.driver[resData.data.driver_code].remove(resData.data.driver_code);

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          } else if (resData.identification == "driver_control" && resData.header == "cut") {
            // 如果接收到司机cut数据

            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {

              // 清除对应的司机标签
              // _this.driver[resData.data.driver_code].setMap(null);
                _this.driver[resData.data.driver_code].remove(resData.data.driver_code);;

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          }

        };



      },


      // 添加司机方法
      addDriver(driver_code, name, lng, lat, status, server_status, dan) {

        // 如果存在筛选项
        // if (_this.checkList.length != 0) {

        // for (let i = 0; i < _this.checkList.length; i++) {

        // 如果接收到的数据status和筛选项一致
        // if (status == _this.checkList[i]) {


        // 根据司机状态决定文本标签的背景色
        switch (String(status)) {
          case '0':

            var backgroundColor = '#B9B9B9';

            break;
          case '1':

            var backgroundColor = '#61D59C';

            break;
          case '2':

            if (server_status == 1) {
              var backgroundColor = '#FA6705';
            } else if (server_status == 2) {
              var backgroundColor = '#BBC22C';
            } else if (server_status == 3) {
              var backgroundColor = '#FADC05';
            } else if (server_status == 4) {
              var backgroundColor = '#FAB105';
            } else if (server_status == 5) {
              var backgroundColor = '#9f3ecc';
            } else if (server_status == 6) {
              var backgroundColor = '#FA4705';
            }



            break;
          case '3':

            var backgroundColor = '#00A4DC';

            break;



          default:
            break;
        }




        // 如果driver_code存在,不需要新添加司机标签
        if (typeof (_this.driver[driver_code]) !== 'undefined') {

          // 如果接收到的数据不存在坐标并且司机标签已经存在，则只改变颜色
          if (lng != undefined && lng != null && lng != '' && lat != undefined && lat != null && lat != '') {
            //更改司机标签的坐标
            _this.driver[driver_code].setGeometries([
              {
                "id": driver_code,
                "styleId": "driverStyle",
                "position": new TMap.LatLng(lat, lng),
                "content": name
              }
            ]);
          }




          // 如果信息窗口存在并且已经打开
          if (_this.driverMarks_status[driver_code]) {


            // 更改司机信息窗口的坐标
            _this.driverMarks_status[driver_code].setPosition(new TMap.LatLng(lat, lng));
            //  console.log(_this.driverMarks_status[driver_code],'_this.driverMarks_status[driver_code]');
          }

            _this.driver[driver_code].setStyles({
                'driverStyle': new TMap.LabelStyle({
                  size: 16, // 文字大小属性
                  padding: "6px 15px",
                  color: "#fff",
                  backgroundColor: backgroundColor,
                })
            });



          return;
        } else if (typeof (_this.driver[driver_code]) == 'undefined' && (lng == undefined || lng == null || lng ==
            '' || lat == undefined || lat == null || lat == '')) {
          //如果driver_code不存在而且也没有坐标点直接直接return



          return;

        }




        // 根据司机状态决定文本标签的背景色
        switch (String(dan)) {
          case '0':

            var driver_logo = require('@/assets/11.png');

            break;
          case '1':

            var driver_logo = require('@/assets/22.png');

            break;
          case '2':

            var driver_logo = require('@/assets/33.png');



            break;
          case '3':

            var driver_logo = require('@/assets/44.png');



            break;

          default:
            break;
        }


        // 创建纯文本标记（司机标签）
        _this.driver[driver_code] = new TMap.MultiLabel({
          map: map,
          styles: {
              "driverStyle": new TMap.LabelStyle({
                  size: 16, // 文字大小属性
                  padding: "6px 15px",
                  color: "#fff",
                  backgroundColor: backgroundColor,
              })
          },
          geometries: [{
              "id": driver_code,
              "styleId": "driverStyle",
              "position": new TMap.LatLng(lat, lng),
              "content": name
          }]
        });

        var position = new TMap.LatLng(lat, lng);
        // 创建信息窗口
        _this.driverMarks_status[driver_code] = new TMap.InfoWindow({
            map: map,
            position: position,
            offset: { x: 0, y: -20 }
        });
         _this.driverMarks_status[driver_code].close()
        // 1秒后清除点标掉落效果的动画(防止点标抖动)
        // setTimeout(() => {

        //   if (_this.driver[driver_code]) {
        //     _this.driver[driver_code].setAnimation('AMAP_ANIMATION_NONE')
        //   }

        // }, 1000);


        // 文本标记的点击事件
        _this.driver[driver_code].on('click', function() {


        _this.$post(
          "/driver/getPerformance", {
            driver_code: driver_code
          }
        ).then(res => {


            if (res.data.logo_img.url == '' || res.data.logo_img.url == null) {

              _this.url = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

            } else {

              _this.url = res.data.logo_img.url;

            }
            _this.is_window_show = true;
             _this.driverMarks_status[driver_code].open()
             var content = '<div style="width:180px;background-color:white;padding: 20px;box-sizing: border-box;border-radius: 5px">' +
                      '<div style="overflow: hidden; width:80px;height:80px;margin:0 auto;border-radius: 50%;">' +
                      '<img style="margin:0 auto;display:block;width:100%;height:100%;" src="' + _this.url +
                      '">' +
                      '</div>' +
                      '<h4 style="text-align: center;font-weight: bold;font-size: 18px">' + name + '</h4>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">今日完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                      res.data.today_order_nums + '单</span> </p>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">本月完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                      res.data.month_order_nums + '单</span> </p>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">任职状态</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                      res.data.capacity + '</span> </p>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">综合指数</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                      res.data.exponent_driver_points_ + '分</span> </p>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">司机电话</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                      res.data.phone + '</span> </p>' +
                      '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">定位时间</span> <span style="display: inline-block;width: 50%;text-align: left;white-space: normal;">' +
                      res.data.position_time.YmdHis + '</span> </p>' +
                      '</div>'
             _this.driverMarks_status[driver_code].setContent(content)
            // 创建信息窗口


          //打开信息窗口
          //  _this.driverMarks_status[driver_code].open(map, _this.driver[driver_code]
          //   .getPosition()); //后面的参数指的是经纬度，在此显示窗口



          }).catch((err) => {

          })


        });
         _this.driverMarks_status[driver_code].on('closeclick', function(){
            console.log('关闭信息窗口');
            _this.is_window_show = false;
          });

        // } else if (_this.checkList.indexOf(Number(status)) == -1) {
        //   //如果司机对应的状态未被勾选


        //   // 如果司机已经存在标签，则删除
        //   if (typeof (_this.driver[driver_code]) !== 'undefined') {

        //     // 清除对应的司机标签
        //     _this.driver[driver_code].setMap(null);

        //     // 将对象中对应的driver_code对象删除
        //     delete _this.driver[driver_code];

        //   }


        // }
        // }
        // }





      },


      // 管理司机信息窗口方法
      closePop() {
        console.log(2222);
        // 遍历关闭信息窗口
        for (const key in _this.driverMarks_status) {
          _this.driverMarks_status[key].close();

        }

      },


      // 状态搜索多选框
      checkboxChenge(e, val) {



        // 如果取消筛选
        if (e == false) {

          for (const key in _this.driver) {

            // 清除所有司机标签
            // _this.driver[key].setMap(null);
            map.remove(_this.driver[key]);
            // _this.driver[key].remove(_this.driver[key]);

            // 清空driver对象
            delete _this.driver[key];

          }

        }

      },



    }
  }
</script>
<style scoped>
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';


  #container {
    width: 100%;
    height: 100vh;
    z-index: 0;
  }

  .checkboxGroup {
    position: absolute;
    top: 25px;
    left: 30px;
    padding: 10px 20px;
    z-index: 1;
    background-color: #fff;
    border-radius: 20px;
    /* min-width: 1000px; */
    width: 200px;
    /* padding: 20px 0; */
  }

  .city-box {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999999999;
  }

  .pull {
    display: flex;
    padding: 20px 5px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-100%, -50%);
    transition: all 0.1s linear;
    justify-content: center;
  }

  .city-group {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    max-width: 300px;
    max-height: 500px;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    cursor: pointer;
    overflow-y: auto;
  }

  .city-group .city-name {
    padding-left: 20px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .city-group .city-name:hover {
    background-color: #ccc;
    transition: .2s;
  }
  .active {
    background-color: #ccc;
  }

  .main-right {
    position: absolute;
    left: 250px;
    top: 25px;
    margin: 0 10px;
  }

  .main-right > div {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 5px;
    padding: 5px;
    width: 400px;
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
  }

  .main-right .left-top-col{
    display: flex;
  }

  .main-right .top .left-top-col{
    position: relative;
  }
  .main-right .top .left-top-col #start-panel {
    position: absolute;
    background-color: white;
    overflow-y: auto;
    top: 34px;
    left: 20px;
    width: 280px;
    z-index: 9999;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  }
  .list {
    cursor: pointer;
    padding: 10px;
    transition: .5s;
    display: flex;

  }

  .list:hover {
    background-color: #eee;
  }

  .list-name {
    color: #409EFF;
    font-size: 14px;
    display: flex;
  }

</style>
<style>
  .checkboxGroup>.div-color {
    font-weight: 800;
    padding: 10px 0;
  }

  .checkboxGroup>.div-color:nth-of-type(2) {
    color: #B9B9B9 !important;

  }

  .checkboxGroup>.div-color:nth-of-type(3) {
    color: #61D59C !important;
  }

  .checkboxGroup>.div-color:nth-of-type(4) {
    color: #00A4DC !important;
  }

  .checkboxGroup>.div-color:nth-of-type(5) {
    color: #FA6705 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(6) {
    color: #BBC22C !important;
  }

  .checkboxGroup>.div-color:nth-of-type(7) {
    color: #FADC05 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(8) {
    color: #FAB105 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(9) {
    color: #9f3ecc !important;
  }

  .checkboxGroup>.div-color:nth-of-type(10) {
    color: #FA4705 !important;
  }
</style>
